import type { ColorScheme } from './types';

/** Applies user-level light/dark preference via the `dark` class on `<html>`. */
export function applyColorScheme(scheme: ColorScheme): void {
  document.documentElement.classList.toggle('dark', scheme === 'dark');
  document.documentElement.dataset['colorScheme'] = scheme;
}
